// extracted by mini-css-extract-plugin
export default {"card":"EZ-z","carouselContainer":"FZ-z","carouselContent":"GZ-z"};